<mat-form-field appearance="legacy" style="height:35px;margin-left:10px;" class="field-full-width">
    <mat-label>Type de consultation</mat-label>
    <mat-select>
        <mat-option *ngFor="let type of types" (click)="selectType(type)" [value]="type">{{ type.name }}</mat-option>
    </mat-select>
</mat-form-field>